import React, { PureComponent } from 'react';

import config from './Modal.config';
import './Modal.less';

class Modal extends PureComponent {
  _preventWrapperClick = event => {
    // Prevent modal-wrapper onClick (onClose) from being triggered
    event.stopPropagation();
  };

  render() {
    const { visible, onClose, children } = this.props;
    if (!visible) return null;

    return (
      <div className="modal show">
        <div className="modal-wrapper" onClick={onClose}>
          <div className="modal-content" onClick={this._preventWrapperClick}>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

Modal.displayName = config.displayName;
Modal.defaultProps = config.defaultProps;
Modal.propTypes = config.propTypes;

export default Modal;
